import { isSocialSecurityNumberValid } from './fields/socialSecurityNumber';

/**
 * Validation
 * @author   Milan Stanojevic
 */
export const maxLength = (max) => (value) =>
	value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const number = (value) =>
	value && isNaN(Number(value)) ? 'Must be a number' : undefined;
export const minValue = (min) => (value) =>
	value && value < min ? `Must be at least ${min}` : undefined;
export const minValueV2 = (min, message) => (value) =>
	value && value < min ? message ?? `Must be at least ${min}` : undefined;
export const minValueAndRequired = (min, message) => (value) =>
	!value ? message ?? `Must be at least ${min}` :
		value && value < min ? message ?? `Must be at least ${min}` : undefined;
export const email = (value) =>
	value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
		? 'Invalid email address'
		: undefined;
export const emailAddress = (message) => (value) =>
	value && !/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/i.test(value)
		? message
		: undefined;

export const duplicateEmail = (message, check) => (value) =>
	check && value ? message : undefined;

export const phoneNumber = (min, message) => (value) =>
	value && value.length < min ? message : undefined;

export const required = (message = 'Required') => {
	return (value) => (value ? undefined : message);
};

export const requiredAlphaNumUnderscore = (message, invalidMessage) => {
	const regex = /^[a-z0-9_]+$/;

	return (value) => {
		if (!value) return message;
		return regex.test(value) ? undefined : invalidMessage;
	};
};

export const positiveNumber = () => (value) => {
	if (value) {
		if (isNaN(value)) {
			return 'Must be a number';
		}

		if (value < 0) {
			return 'Must be a positive number';
		}

		if (value % 1 !== 0) {
			return 'Must be a whole number';
		}
	}
	return undefined;
};

export const minLength =
	(min, message = 'Required') =>
		(value) =>
			value && value.length < min ? message : undefined;

export const fileUploading = (message = 'Required') => {
	return (value) => (value == 'loading' ? message : undefined);
};

export const fileUploadingRequired = (message = 'Required') => {
	return (value) =>
		value == 'loading' ? message : value ? undefined : message;
};

export const dateValidate = (message) => (value) =>
	new Date(value) instanceof Date && !isNaN(value) ? message : undefined;

export const validateGender = (canHaveOther, lang) => (value) => {
	if (value) {
		if (['male', 'female'].includes(value)) return undefined;
		if (!canHaveOther)
			return 'Please select either male or female as your gender!'.translate(
				lang
			);
		if (value === 'other')
			return 'Please enter your preferred gender!'.translate(lang);
	}

	return undefined;
};

export const checkSocialSecurityNumber =
	(message = 'Social security number is not valid!', country) =>
		(value) => {
			if (!country) {
				if (
					typeof window !== 'undefined' &&
					localStorage &&
					localStorage?.getItem?.('country')
				)
					country = localStorage?.getItem?.('country');
				else country = 'sweden';
			}
			const isValid = isSocialSecurityNumberValid(value, country);
			if (isValid) return undefined;
			return message;
		};

// between validation with optional inclusive
export const between =
	(min, max, message, inclusive = true) =>
		(value) => {
			if (value === undefined || value === null || value === '') return undefined;

			if (inclusive) {
				if (value < min || value > max) {
					return message;
				}
			} else {
				if (value <= min || value >= max) {
					return message;
				}
			}

			return undefined;
		};
